import { MediumText } from "../../../../../components/typography";
// import bgCard from '../../../../../assets/images/bg-card.png';

export default function TypeItemPaymentTab() {
    return (
        <MediumText>Спосіб оплати елемент</MediumText>
        // <img src={bgCard} alt="card-background" />
    )
}